import React from 'react';
import Styles from './portfolio-card-big.scss';
import GeneralAccount from '@/presentation/components/icons/general-account';
import ButtonKVBase from '../../../../components/button-kv/button-kv';
import { IconActivity } from '../../../../components/icons';
import useValidateUserActivity from '@/presentation/hooks/use-validate-user-activity';
const PortfolioCardBig = ({ title, setModalConfirm, subtitle, subtext }) => {
    const { isAllowed, isLoading: isLoadingActivity } = useValidateUserActivity('STOCK_TRADING');
    return (React.createElement("div", { className: Styles.lifetimeEarningsContainer },
        React.createElement("h3", { className: Styles.title }, title),
        React.createElement("div", { className: Styles.content },
            React.createElement(GeneralAccount, null),
            React.createElement("h3", { className: Styles.subtitle }, subtitle),
            React.createElement("h3", { className: Styles.subtext }, subtext)),
        React.createElement("br", null),
        setModalConfirm && (React.createElement(ButtonKVBase, { onClick: () => setModalConfirm(true), type: "button", rightIcon: React.createElement(IconActivity, { color: "white" }), btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", disabled: !isAllowed || isLoadingActivity }, 'Start Trading'))));
};
export default PortfolioCardBig;
